module.exports = __webpack_public_path__ + "static/media/terminos_y_condiciones_wom_abril_2022.6b69c399.pdf";